import { useEffect, useState } from "react";
import { PartyPopper } from "lucide-react";
import { api } from "@/lib/api";

export default function CountdownMeter() {
  const [stats, setStats] = useState({ paid_people: 0, target: 30, remaining: 30, location_revealed: false });
  useEffect(() => {
    api.get("/events/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);
  const pct = Math.min(100, (stats.paid_people / stats.target) * 100);
  const almostThere = !stats.location_revealed && stats.remaining < 10;
  return (
    <div data-testid="event-countdown">
      {(almostThere || stats.location_revealed) && (
        <div className="festive-banner flex items-center gap-3 px-4 py-3 mb-5 border border-[#D4AF37] bg-[#D4AF37]/10" data-testid="festive-banner">
          <PartyPopper size={20} className="text-[#E4BD44] festive-bounce shrink-0" />
          <p className="text-sm font-semibold">
            {stats.location_revealed
              ? "Quota raggiunta! La location segreta sta per essere svelata. 🥂"
              : `Ci siamo quasi: solo ${stats.remaining} ${stats.remaining === 1 ? "posto" : "posti"} alla rivelazione della location segreta!`}
          </p>
        </div>
      )}
      <div className="flex items-baseline justify-between mb-3">
        <span className="font-display text-4xl sm:text-5xl font-bold">
          {stats.paid_people}<span className="text-[#9a9484] text-2xl">/{stats.target}</span>
        </span>
        <span className="text-xs uppercase tracking-[0.18em] text-[#C9C4B8]">partecipanti paganti</span>
      </div>
      <div className="h-1.5 bg-[#2A2A2A] w-full">
        <div className={`h-full transition-[width] duration-700 ${almostThere ? "bg-[#D4AF37]" : "bg-[#E4BD44]"}`} style={{ width: `${pct}%` }} />
      </div>
      <p className="mt-3 text-sm text-[#C9C4B8]">
        {stats.location_revealed
          ? "Quota raggiunta! La location segreta sta per essere rivelata agli iscritti."
          : `Mancano ${stats.remaining} partecipanti alla rivelazione della location segreta.`}
      </p>
    </div>
  );
}
